export default __webpack_public_path__ + "static/media/cortado.30b4f600.png";